const styles = () => ({
  table: {
    borderCollapse: 'separate',
    borderSpacing: '0px 8px',
  },
})

export default styles
